import { useEffect, useState } from "react";
import { Grid, Card, CardContent } from "@mui/material";
import { Helmet } from "react-helmet-async";
import MonthlyAds from "./Charts/MonthlyAds";
import MonthlyUsers from "./Charts/MonthlyUsers";
import MonthlyOfferComparison from "./Charts/MonthlyOfferComparison";
import AnalyticsTracker from "../GASetup/AnalyticsTracker";
import LoadingAnimation from "../Animations/LoadingAnimation";
import NewWelcomeCard from "./WelcomeCard";
import DashboardItems from "./DashboardItems";
import TotalAds from "./Charts/TotalAds";
import TotalUsers from "./Charts/TotalUsers";
import TotalChats from "./Charts/TotalChats";
import { cardOutline } from "../../Styles/Styles";

export default function Dashboard({ unreadNotifications, unreadMessages }) {
  const [loading, setLoading] = useState(false);
  const [profileCompletion, setProfileCompletion] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role;

  useEffect(() => {
    const fetchProfileCompletion = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/user/profile-completion`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch profile completion");
        }

        const data = await response.json();
        setProfileCompletion(data.completionPercentage);
      } catch (error) {
        console.error("Error fetching profile completion:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProfileCompletion();
  }, []);

  if (loading) {
    return <LoadingAnimation />;
  }

  return (
    <Grid container sx={{ padding: 3 }}>
      <Helmet>
        <title>Dashboard - Listed.ky</title>
        <meta name="description" content="Dashboard - Listed.ky" />
      </Helmet>
      <AnalyticsTracker />
      <Grid container>
        <NewWelcomeCard user={user} profileCompletion={profileCompletion} />
      </Grid>
      <Grid container sx={{ mt: 3 }}>
        <DashboardItems
          unreadNotifications={unreadNotifications}
          unreadMessages={unreadMessages}
        />
      </Grid>
      {userRole === "superAdmin" && (
        <>
          <Grid container spacing={3} sx={{ mt: 3 }}>
            {/* Monthly Ads Statistics */}
            <Grid item xs={12} sm={12} md={4}>
              <Card sx={{ ...cardOutline }}>
                <CardContent>
                  <TotalAds />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Card sx={{ ...cardOutline }}>
                <CardContent>
                  <TotalUsers />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Card sx={{ ...cardOutline }}>
                <CardContent>
                  <TotalChats />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ mt: 3 }}>
            {/* Monthly Ads Statistics */}
            <Grid item xs={12} md={12}>
              <Card sx={{ ...cardOutline }}>
                <CardContent>
                  <MonthlyAds />
                </CardContent>
              </Card>
            </Grid>

            {/* Placeholder for Additional Content */}
            <Grid item xs={12} md={12}>
              <Card sx={{ ...cardOutline }}>
                <CardContent>
                  <MonthlyUsers />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={12}>
              <Card sx={{ ...cardOutline }}>
                <CardContent>
                  <MonthlyOfferComparison />
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  );
}
